import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import pestReportService from "../api/pestReportService";

const LEVELS = {
  1: { label: "Nivel 1", color: "#ca8a04", bg: "#fefce8" },
  2: { label: "Nivel 2", color: "#ea580c", bg: "#fff7ed" },
  3: { label: "Nivel 3", color: "#dc2626", bg: "#fef2f2" },
};

const STYLES = `
  .phb-root {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 16px;
    border: 1.5px solid #e4e7ed;
    overflow: hidden;
    box-shadow: 0 4px 24px rgba(15,17,23,0.06), 0 1px 4px rgba(15,17,23,0.04);
    font-family: system-ui, -apple-system, "Segoe UI", sans-serif;
  }
  .phb-head {
    padding: 10px 12px 8px;
    border-bottom: 1.5px solid #f0f2f6;
    background: linear-gradient(180deg, #fafbfd 0%, #ffffff 100%);
    flex-shrink: 0;
  }
  .phb-title { font-size: 12px; font-weight: 700; color: #0f1117; }
  .phb-sub { font-size: 11px; color: #9ba3b5; margin-top: 2px; }
  .phb-body {
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }
  .phb-row {
    padding: 7px 12px 6px;
    border-bottom: 1px solid #f0f2f6;
  }
  .phb-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }
  .phb-name {
    font-size: 12px;
    font-weight: 600;
    color: #0f1117;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .phb-count {
    flex-shrink: 0;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.02em;
    border-radius: 999px;
    padding: 2px 7px;
    white-space: nowrap;
  }
  .phb-bar {
    margin-top: 5px;
    height: 3px;
    border-radius: 99px;
    background: #f1f5f9;
    overflow: hidden;
  }
  .phb-fill { height: 100%; border-radius: 99px; }
  .phb-empty {
    padding: 22px 12px;
    text-align: center;
    font-size: 12px;
    color: #9ba3b5;
  }
`;

function levelMeta(value) {
  const n = Number(value);
  return LEVELS[n] || { label: `Nivel ${n}`, color: "#64748b", bg: "#f8fafc" };
}

function branchLabel(count) {
  const n = Number(count) || 0;
  return n === 1 ? "1 suc." : `${n} suc.`;
}

export default function PestHotBranches() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    pestReportService
      .getHotBranches()
      .then((data) => {
        if (alive) setRows(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (alive) setRows([]);
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  const maxCount = rows.reduce(
    (max, row) => Math.max(max, Number(row.infestedBranches) || 0),
    0
  );

  return (
    <Box className="phb-root">
      <style>{STYLES}</style>
      <div className="phb-head">
        <div className="phb-title">Clientes con más sucursales infestadas</div>
        <div className="phb-sub">Según el último reporte de cada sucursal</div>
      </div>
      <div className="phb-body">
        {loading && <div className="phb-empty">Cargando clientes…</div>}
        {!loading && rows.length === 0 && (
          <div className="phb-empty">Aún no hay reportes</div>
        )}
        {rows.map((row) => {
          const meta = levelMeta(row.maxPestLevel);
          const count = Number(row.infestedBranches) || 0;
          const width = `${maxCount ? Math.min(100, (count / maxCount) * 100) : 0}%`;
          return (
            <div key={row.clientId} className="phb-row">
              <div className="phb-top">
                <span className="phb-name">{row.clientName}</span>
                <span className="phb-count" style={{ color: meta.color, background: meta.bg }}>
                  {branchLabel(count)}
                </span>
              </div>
              <div className="phb-bar">
                <div className="phb-fill" style={{ width, background: meta.color }} />
              </div>
            </div>
          );
        })}
      </div>
    </Box>
  );
}
